import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-social-popup',
  templateUrl: './social-popup.component.html',
  styleUrls: ['./social-popup.component.scss']
})
export class SocialPopupComponent implements OnInit {

  public params;
  public social: string | undefined;
  public sso_token: string | undefined;
  public sso_franchise: string | undefined;
  public username: string | undefined;
  public wait_message = `${this._translation.instant('sso.login.pleasewait')}`;

  constructor(
    public _http: HttpClient,
    private _route: ActivatedRoute,
    public _translation: TranslateService,
  ) { }

  ngOnInit(): void {
    this._route.url.subscribe(segments => {
      const urlSegment = segments[1]?.path;
      this.social = urlSegment;
    });

    this.params = this._route.snapshot.queryParams;
    this.sendStateToLaravel();
  }

  sendStateToLaravel() {
    const callbackUrl = '/authorized/'+this.social+'/callback2';

    const params = new HttpParams().set('state', this.params['state']).set('code', this.params['code']).set('scope', this.params['scope']).set('authuser', this.params['authuser']).set('prompt', this.params['prompt']);

    this._http.get(callbackUrl, { params: params }).subscribe(
      response => {
        if(response['message']=='success'){
          this.sso_token = response['sso_token'];
          this.sso_franchise = response['sso_franchise'];
          this.username = response['username'];
          this.onClose();
        }
        else{
          this.sso_token = '';
          this.sso_franchise = '';
          this.username = '';
          this.onClose();
        }
        //console.log('Response from Laravel:', response);
        // Handle response from Laravel if needed
      },
      error => {
        console.error('Error while sending data to Laravel:', error);
        // Handle error if needed
      }
    );
  }

  public onClose(){
    if(window.opener) {
      const customEvent = new CustomEvent('socialPopup', { detail: {
        sso_token: this.sso_token,
        sso_franchise: this.sso_franchise,
        username: this.username
      }});
      
      window.opener.dispatchEvent(customEvent);
      window.open('','_parent','');
      window.close();
    }
  }

}
